module.exports = __webpack_public_path__ + "static/media/nav-refunds-hover.1a14ee60.svg";